import { render, staticRenderFns } from "./edit-registration.vue?vue&type=template&id=3d8d33e3"
import script from "./edit-registration.vue?vue&type=script&lang=js"
export * from "./edit-registration.vue?vue&type=script&lang=js"
import style0 from "./edit-registration.vue?vue&type=style&index=0&id=3d8d33e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports